// GENERATED by art-src/map-painted-world-v2/export.py — do not edit by hand. Painted world v2 runtime art
// metadata (Oct 15 2026): every size and point is in the exported image's own px (x right, y down).
// Contacts, roof mounts and bridge ends are the package's ESTIMATES carried through the export transform;
// shore and wall orientations are measured from the art by the export script. paintedWorld.ts calibrates them.
/* eslint-disable */
export const PAINTED_WORLD_DATA = {
 "castles": {
  "you:1": {
   "file": "castles/you-1.webp",
   "w": 417,
   "h": 435,
   "scale": 1.0,
   "painted": [
    6,
    6,
    411,
    429
   ],
   "solid": [
    14,
    7,
    410,
    428
   ],
   "contact": [
    208.0,
    428.0
   ],
   "roof": [
    190.81,
    7.0
   ]
  },
  "you:2": {
   "file": "castles/you-2.webp",
   "w": 448,
   "h": 424,
   "scale": 0.906883,
   "painted": [
    5,
    6,
    443,
    419
   ],
   "solid": [
    9,
    7,
    442,
    417
   ],
   "contact": [
    223.55,
    417.17
   ],
   "roof": [
    228.08,
    7.26
   ]
  },
  "you:3": {
   "file": "castles/you-3.webp",
   "w": 446,
   "h": 448,
   "scale": 0.885375,
   "painted": [
    5,
    5,
    441,
    442
   ],
   "solid": [
    11,
    9,
    440,
    441
   ],
   "contact": [
    222.67,
    441.8
   ],
   "roof": [
    220.99,
    9.74
   ]
  },
  "you:4": {
   "file": "castles/you-4.webp",
   "w": 448,
   "h": 441,
   "scale": 0.807207,
   "painted": [
    5,
    5,
    444,
    436
   ],
   "solid": [
    12,
    6,
    443,
    435
   ],
   "contact": [
    223.6,
    435.08
   ],
   "roof": [
    227.05,
    6.46
   ]
  },
  "guild:1": {
   "file": "castles/guild-1.webp",
   "w": 425,
   "h": 439,
   "scale": 1.0,
   "painted": [
    6,
    6,
    419,
    433
   ],
   "solid": [
    7,
    8,
    417,
    432
   ],
   "contact": [
    212.0,
    432.0
   ],
   "roof": [
    197.24,
    9.0
   ]
  },
  "guild:2": {
   "file": "castles/guild-2.webp",
   "w": 448,
   "h": 421,
   "scale": 0.89243,
   "painted": [
    5,
    5,
    443,
    416
   ],
   "solid": [
    7,
    7,
    442,
    415
   ],
   "contact": [
    223.55,
    414.98
   ],
   "roof": [
    229.81,
    8.92
   ]
  },
  "guild:3": {
   "file": "castles/guild-3.webp",
   "w": 447,
   "h": 448,
   "scale": 0.878431,
   "painted": [
    5,
    5,
    442,
    442
   ],
   "solid": [
    6,
    7,
    441,
    441
   ],
   "contact": [
    223.12,
    441.85
   ],
   "roof": [
    222.61,
    7.91
   ]
  },
  "guild:4": {
   "file": "castles/guild-4.webp",
   "w": 448,
   "h": 445,
   "scale": 0.811594,
   "painted": [
    4,
    5,
    443,
    440
   ],
   "solid": [
    6,
    6,
    442,
    439
   ],
   "contact": [
    223.59,
    439.07
   ],
   "roof": [
    225.01,
    6.49
   ]
  },
  "ally:1": {
   "file": "castles/ally-1.webp",
   "w": 428,
   "h": 439,
   "scale": 1.0,
   "painted": [
    6,
    6,
    422,
    433
   ],
   "solid": [
    7,
    7,
    421,
    432
   ],
   "contact": [
    213.5,
    432.0
   ],
   "roof": [
    199.06,
    8.0
   ]
  },
  "ally:2": {
   "file": "castles/ally-2.webp",
   "w": 448,
   "h": 417,
   "scale": 0.883629,
   "painted": [
    5,
    6,
    443,
    411
   ],
   "solid": [
    6,
    7,
    442,
    410
   ],
   "contact": [
    223.56,
    410.89
   ],
   "roof": [
    231.11,
    8.84
   ]
  },
  "ally:3": {
   "file": "castles/ally-3.webp",
   "w": 448,
   "h": 444,
   "scale": 0.869903,
   "painted": [
    6,
    5,
    443,
    439
   ],
   "solid": [
    7,
    6,
    442,
    438
   ],
   "contact": [
    223.57,
    437.56
   ],
   "roof": [
    224.46,
    6.09
   ]
  },
  "ally:4": {
   "file": "castles/ally-4.webp",
   "w": 448,
   "h": 435,
   "scale": 0.79292,
   "painted": [
    5,
    5,
    443,
    430
   ],
   "solid": [
    6,
    6,
    442,
    429
   ],
   "contact": [
    223.6,
    428.97
   ],
   "roof": [
    229.59,
    7.14
   ]
  },
  "nap:1": {
   "file": "castles/nap-1.webp",
   "w": 428,
   "h": 439,
   "scale": 1.0,
   "painted": [
    6,
    6,
    422,
    433
   ],
   "solid": [
    7,
    8,
    421,
    432
   ],
   "contact": [
    213.5,
    432.0
   ],
   "roof": [
    199.0,
    8.0
   ]
  },
  "nap:2": {
   "file": "castles/nap-2.webp",
   "w": 448,
   "h": 414,
   "scale": 0.88189,
   "painted": [
    5,
    5,
    443,
    409
   ],
   "solid": [
    6,
    6,
    441,
    408
   ],
   "contact": [
    223.56,
    407.43
   ],
   "roof": [
    231.26,
    7.06
   ]
  },
  "nap:3": {
   "file": "castles/nap-3.webp",
   "w": 448,
   "h": 443,
   "scale": 0.871595,
   "painted": [
    5,
    5,
    443,
    438
   ],
   "solid": [
    6,
    7,
    442,
    437
   ],
   "contact": [
    223.56,
    436.67
   ],
   "roof": [
    224.27,
    7.84
   ]
  },
  "nap:4": {
   "file": "castles/nap-4.webp",
   "w": 448,
   "h": 430,
   "scale": 0.788732,
   "painted": [
    5,
    5,
    444,
    425
   ],
   "solid": [
    6,
    6,
    443,
    424
   ],
   "contact": [
    223.61,
    424.34
   ],
   "roof": [
    230.27,
    5.52
   ]
  },
  "enemy:1": {
   "file": "castles/enemy-1.webp",
   "w": 429,
   "h": 439,
   "scale": 1.0,
   "painted": [
    6,
    6,
    423,
    433
   ],
   "solid": [
    7,
    7,
    422,
    432
   ],
   "contact": [
    214.0,
    432.0
   ],
   "roof": [
    200.11,
    8.0
   ]
  },
  "enemy:2": {
   "file": "castles/enemy-2.webp",
   "w": 448,
   "h": 416,
   "scale": 0.885375,
   "painted": [
    5,
    5,
    443,
    411
   ],
   "solid": [
    6,
    6,
    442,
    410
   ],
   "contact": [
    223.56,
    409.93
   ],
   "roof": [
    231.01,
    7.97
   ]
  },
  "enemy:3": {
   "file": "castles/enemy-3.webp",
   "w": 448,
   "h": 443,
   "scale": 0.868217,
   "painted": [
    5,
    6,
    443,
    438
   ],
   "solid": [
    7,
    7,
    442,
    437
   ],
   "contact": [
    223.57,
    436.71
   ],
   "roof": [
    223.77,
    6.95
   ]
  },
  "enemy:4": {
   "file": "castles/enemy-4.webp",
   "w": 448,
   "h": 434,
   "scale": 0.79292,
   "painted": [
    5,
    5,
    444,
    429
   ],
   "solid": [
    6,
    6,
    443,
    428
   ],
   "contact": [
    223.6,
    428.18
   ],
   "roof": [
    229.29,
    5.55
   ]
  },
  "unaligned:1": {
   "file": "castles/unaligned-1.webp",
   "w": 429,
   "h": 438,
   "scale": 1.0,
   "painted": [
    6,
    6,
    423,
    432
   ],
   "solid": [
    7,
    7,
    422,
    431
   ],
   "contact": [
    214.0,
    431.0
   ],
   "roof": [
    200.1,
    8.0
   ]
  },
  "unaligned:2": {
   "file": "castles/unaligned-2.webp",
   "w": 448,
   "h": 414,
   "scale": 0.88189,
   "painted": [
    6,
    5,
    443,
    408
   ],
   "solid": [
    7,
    6,
    442,
    407
   ],
   "contact": [
    223.56,
    408.31
   ],
   "roof": [
    231.79,
    7.94
   ]
  },
  "unaligned:3": {
   "file": "castles/unaligned-3.webp",
   "w": 448,
   "h": 442,
   "scale": 0.868217,
   "painted": [
    5,
    5,
    443,
    436
   ],
   "solid": [
    6,
    6,
    442,
    435
   ],
   "contact": [
    223.57,
    435.84
   ],
   "roof": [
    224.83,
    6.08
   ]
  },
  "unaligned:4": {
   "file": "castles/unaligned-4.webp",
   "w": 448,
   "h": 431,
   "scale": 0.788732,
   "painted": [
    5,
    5,
    444,
    426
   ],
   "solid": [
    6,
    6,
    443,
    425
   ],
   "contact": [
    223.61,
    425.13
   ],
   "roof": [
    231.01,
    6.31
   ]
  }
 },
 "pennants": {
  "you": {
   "file": "pennants/you.webp",
   "w": 160,
   "h": 113,
   "scale": 0.34188,
   "painted": [
    2,
    2,
    158,
    111
   ]
  },
  "guild": {
   "file": "pennants/guild.webp",
   "w": 160,
   "h": 112,
   "scale": 0.339703,
   "painted": [
    2,
    2,
    158,
    110
   ]
  },
  "ally": {
   "file": "pennants/ally.webp",
   "w": 160,
   "h": 113,
   "scale": 0.341151,
   "painted": [
    2,
    2,
    158,
    111
   ]
  },
  "nap": {
   "file": "pennants/nap.webp",
   "w": 160,
   "h": 113,
   "scale": 0.34188,
   "painted": [
    2,
    2,
    158,
    111
   ]
  },
  "enemy": {
   "file": "pennants/enemy.webp",
   "w": 160,
   "h": 113,
   "scale": 0.341151,
   "painted": [
    2,
    2,
    158,
    111
   ]
  },
  "unaligned": {
   "file": "pennants/unaligned.webp",
   "w": 160,
   "h": 113,
   "scale": 0.343348,
   "painted": [
    2,
    2,
    158,
    111
   ]
  }
 },
 "bridges": [
  {
   "file": "bridges/stream-1.webp",
   "w": 320,
   "h": 129,
   "scale": 0.851064,
   "type": "river",
   "angleDeg": 0.09487,
   "centre": [
    159.85,
    68.86
   ],
   "ends": [
    [
     17.06,
     68.62
    ],
    [
     302.94,
     69.09
    ]
   ],
   "span": 285.88,
   "painted": [
    5,
    5,
    315,
    124
   ]
  },
  {
   "file": "bridges/stream-2.webp",
   "w": 320,
   "h": 192,
   "scale": 0.848806,
   "type": "river",
   "angleDeg": 163.54719,
   "centre": [
    158.43,
    100.05
   ],
   "ends": [
    [
     26.04,
     139.15
    ],
    [
     289.87,
     61.23
    ]
   ],
   "span": 275.1,
   "painted": [
    5,
    5,
    315,
    187
   ]
  },
  {
   "file": "bridges/stream-3.webp",
   "w": 320,
   "h": 300,
   "scale": 0.955224,
   "type": "river",
   "angleDeg": 138.99186,
   "centre": [
    157.2,
    152.58
   ],
   "ends": [
    [
     42.26,
     252.53
    ],
    [
     271.7,
     53.02
    ]
   ],
   "span": 304.05,
   "painted": [
    6,
    6,
    314,
    294
   ]
  },
  {
   "file": "bridges/stream-4.webp",
   "w": 227,
   "h": 320,
   "scale": 0.92219,
   "type": "river",
   "angleDeg": 114.06803,
   "centre": [
    110.76,
    158.84
   ],
   "ends": [
    [
     51.53,
     291.44
    ],
    [
     170.13,
     25.9
    ]
   ],
   "span": 290.82,
   "painted": [
    6,
    5,
    221,
    314
   ]
  },
  {
   "file": "bridges/stream-5.webp",
   "w": 140,
   "h": 320,
   "scale": 0.888889,
   "type": "river",
   "angleDeg": 90.10297,
   "centre": [
    69.57,
    160.2
   ],
   "ends": [
    [
     69.31,
     303.08
    ],
    [
     69.83,
     14.31
    ]
   ],
   "span": 288.77,
   "painted": [
    6,
    5,
    135,
    315
   ]
  },
  {
   "file": "bridges/stream-6.webp",
   "w": 271,
   "h": 320,
   "scale": 0.938416,
   "type": "river",
   "angleDeg": 57.04284,
   "centre": [
    137.33,
    159.9
   ],
   "ends": [
    [
     55.38,
     33.5
    ],
    [
     217.44,
     283.46
    ]
   ],
   "span": 297.9,
   "painted": [
    6,
    6,
    265,
    314
   ]
  },
  {
   "file": "bridges/stream-7.webp",
   "w": 320,
   "h": 315,
   "scale": 0.987654,
   "type": "river",
   "angleDeg": 44.05013,
   "centre": [
    163.61,
    158.67
   ],
   "ends": [
    [
     52.04,
     50.74
    ],
    [
     273.87,
     265.34
    ]
   ],
   "span": 308.64,
   "painted": [
    6,
    6,
    314,
    309
   ]
  },
  {
   "file": "bridges/stream-8.webp",
   "w": 320,
   "h": 200,
   "scale": 0.842105,
   "type": "river",
   "angleDeg": 17.75242,
   "centre": [
    160.8,
    101.88
   ],
   "ends": [
    [
     26.96,
     59.03
    ],
    [
     294.06,
     144.54
    ]
   ],
   "span": 280.45,
   "painted": [
    5,
    5,
    315,
    195
   ]
  },
  {
   "file": "bridges/gorge-1.webp",
   "w": 320,
   "h": 103,
   "scale": 0.772947,
   "type": "rift",
   "angleDeg": 179.95412,
   "centre": [
    159.8,
    50.77
   ],
   "ends": [
    [
     16.2,
     50.88
    ],
    [
     303.74,
     50.65
    ]
   ],
   "span": 287.54,
   "painted": [
    5,
    4,
    315,
    98
   ]
  },
  {
   "file": "bridges/gorge-2.webp",
   "w": 320,
   "h": 198,
   "scale": 0.786241,
   "type": "rift",
   "angleDeg": 23.22317,
   "centre": [
    167.67,
    98.1
   ],
   "ends": [
    [
     34.28,
     40.86
    ],
    [
     293.42,
     152.06
    ]
   ],
   "span": 281.99,
   "painted": [
    5,
    5,
    316,
    193
   ]
  },
  {
   "file": "bridges/gorge-3.webp",
   "w": 320,
   "h": 255,
   "scale": 0.837696,
   "type": "rift",
   "angleDeg": 35.93791,
   "centre": [
    165.93,
    127.11
   ],
   "ends": [
    [
     42.11,
     37.35
    ],
    [
     283.95,
     212.65
    ]
   ],
   "span": 298.69,
   "painted": [
    5,
    5,
    315,
    250
   ]
  },
  {
   "file": "bridges/gorge-4.webp",
   "w": 274,
   "h": 320,
   "scale": 0.969697,
   "type": "rift",
   "angleDeg": 56.02159,
   "centre": [
    141.08,
    162.49
   ],
   "ends": [
    [
     52.86,
     31.6
    ],
    [
     224.79,
     286.69
    ]
   ],
   "span": 307.62,
   "painted": [
    5,
    5,
    269,
    314
   ]
  },
  {
   "file": "bridges/gorge-5.webp",
   "w": 138,
   "h": 320,
   "scale": 0.958084,
   "type": "rift",
   "angleDeg": 90.08551,
   "centre": [
    68.23,
    163.55
   ],
   "ends": [
    [
     68.02,
     304.66
    ],
    [
     68.45,
     17.32
    ]
   ],
   "span": 287.34,
   "painted": [
    6,
    6,
    132,
    314
   ]
  },
  {
   "file": "bridges/gorge-6.webp",
   "w": 283,
   "h": 320,
   "scale": 0.966767,
   "type": "rift",
   "angleDeg": 53.93044,
   "centre": [
    144.67,
    162.01
   ],
   "ends": [
    [
     51.72,
     34.41
    ],
    [
     233.17,
     283.52
    ]
   ],
   "span": 308.19,
   "painted": [
    6,
    5,
    277,
    315
   ]
  },
  {
   "file": "bridges/gorge-7.webp",
   "w": 320,
   "h": 265,
   "scale": 0.864865,
   "type": "rift",
   "angleDeg": 142.16491,
   "centre": [
    152.27,
    131.21
   ],
   "ends": [
    [
     34.87,
     222.38
    ],
    [
     277.75,
     33.75
    ]
   ],
   "span": 307.53,
   "painted": [
    5,
    5,
    315,
    260
   ]
  },
  {
   "file": "bridges/gorge-8.webp",
   "w": 320,
   "h": 178,
   "scale": 0.771084,
   "type": "rift",
   "angleDeg": 162.34243,
   "centre": [
    152.1,
    88.14
   ],
   "ends": [
    [
     22.41,
     129.42
    ],
    [
     289.03,
     44.55
    ]
   ],
   "span": 279.8,
   "painted": [
    5,
    4,
    316,
    174
   ]
  },
  {
   "file": "bridges/gorge-steep-1.webp",
   "w": 296,
   "h": 448,
   "scale": 0.391608,
   "type": "rift",
   "angleDeg": 118.56342,
   "centre": [
    141.88,
    228.04
   ],
   "ends": [
    [
     38.79,
     417.41
    ],
    [
     249.34,
     30.65
    ]
   ],
   "span": 440.36,
   "painted": [
    2,
    2,
    294,
    446
   ]
  }
 ],
 "trees": [
  {
   "file": "scenery/tree-1.webp",
   "w": 124,
   "h": 192,
   "scale": 0.476427,
   "painted": [
    3,
    3,
    121,
    189
   ],
   "foot": [
    62.0,
    180
   ],
   "crowns": 1
  },
  {
   "file": "scenery/tree-2.webp",
   "w": 127,
   "h": 192,
   "scale": 0.554913,
   "painted": [
    3,
    3,
    124,
    189
   ],
   "foot": [
    63.5,
    179
   ],
   "crowns": 1
  },
  {
   "file": "scenery/tree-3.webp",
   "w": 124,
   "h": 192,
   "scale": 0.467153,
   "painted": [
    2,
    3,
    121,
    189
   ],
   "foot": [
    61.5,
    179
   ],
   "crowns": 2
  },
  {
   "file": "scenery/tree-4.webp",
   "w": 190,
   "h": 192,
   "scale": 0.6,
   "painted": [
    4,
    4,
    187,
    189
   ],
   "foot": [
    95.0,
    181
   ],
   "crowns": 1
  }
 ],
 "rocks": [
  {
   "file": "scenery/rock-1.webp",
   "w": 192,
   "h": 110,
   "scale": 0.443418,
   "painted": [
    2,
    2,
    189,
    107
   ],
   "foot": [
    96.0,
    107
   ]
  },
  {
   "file": "scenery/rock-2.webp",
   "w": 192,
   "h": 150,
   "scale": 0.498701,
   "painted": [
    3,
    3,
    189,
    147
   ],
   "foot": [
    96.5,
    147
   ]
  },
  {
   "file": "scenery/rock-3.webp",
   "w": 192,
   "h": 114,
   "scale": 0.472906,
   "painted": [
    2,
    3,
    189,
    112
   ],
   "foot": [
    96.0,
    111
   ]
  },
  {
   "file": "scenery/rock-4.webp",
   "w": 192,
   "h": 148,
   "scale": 0.553314,
   "painted": [
    3,
    3,
    189,
    145
   ],
   "foot": [
    96.0,
    144
   ]
  }
 ],
 "reeds": [
  {
   "file": "scenery/reed-1.webp",
   "w": 192,
   "h": 192,
   "scale": 0.510638,
   "painted": [
    3,
    3,
    189,
    189
   ],
   "foot": [
    96.0,
    188
   ]
  },
  {
   "file": "scenery/reed-2.webp",
   "w": 137,
   "h": 192,
   "scale": 0.411135,
   "painted": [
    3,
    2,
    135,
    189
   ],
   "foot": [
    67.5,
    188
   ]
  },
  {
   "file": "scenery/reed-3.webp",
   "w": 192,
   "h": 118,
   "scale": 0.462651,
   "painted": [
    3,
    3,
    189,
    115
   ],
   "foot": [
    95.5,
    114
   ]
  },
  {
   "file": "scenery/reed-4.webp",
   "w": 192,
   "h": 141,
   "scale": 0.463768,
   "painted": [
    3,
    3,
    190,
    138
   ],
   "foot": [
    97.0,
    138
   ]
  }
 ],
 "shores": [
  {
   "file": "edges/shore-1.webp",
   "w": 320,
   "h": 157,
   "scale": 0.794045,
   "anchor": [
    168.98,
    108.02
   ],
   "tangentDeg": 178.06,
   "waterNormal": [
    0.3614,
    0.9324
   ],
   "length": 245.53,
   "waterFraction": 0.29,
   "painted": [
    5,
    5,
    315,
    152
   ]
  },
  {
   "file": "edges/shore-2.webp",
   "w": 320,
   "h": 276,
   "scale": 0.92219,
   "anchor": [
    146.32,
    181.43
   ],
   "tangentDeg": 38.36,
   "waterNormal": [
    -0.3128,
    0.9498
   ],
   "length": 294.63,
   "waterFraction": 0.267,
   "painted": [
    6,
    5,
    315,
    270
   ]
  },
  {
   "file": "edges/shore-3.webp",
   "w": 245,
   "h": 320,
   "scale": 0.996885,
   "anchor": [
    93.79,
    166.39
   ],
   "tangentDeg": 64.92,
   "waterNormal": [
    -0.9479,
    0.3187
   ],
   "length": 266.35,
   "waterFraction": 0.227,
   "painted": [
    6,
    6,
    239,
    314
   ]
  },
  {
   "file": "edges/shore-4.webp",
   "w": 297,
   "h": 320,
   "scale": 0.993789,
   "anchor": [
    109.85,
    171.85
   ],
   "tangentDeg": 51.63,
   "waterNormal": [
    -0.999,
    0.0451
   ],
   "length": 275.45,
   "waterFraction": 0.28,
   "painted": [
    6,
    6,
    291,
    314
   ]
  },
  {
   "file": "edges/shore-5.webp",
   "w": 320,
   "h": 131,
   "scale": 0.784314,
   "anchor": [
    163.6,
    45.38
   ],
   "tangentDeg": 1.02,
   "waterNormal": [
    0.049,
    -0.9988
   ],
   "length": 230.92,
   "waterFraction": 0.264,
   "painted": [
    5,
    5,
    315,
    126
   ]
  },
  {
   "file": "edges/shore-6.webp",
   "w": 312,
   "h": 302,
   "scale": 1.0,
   "anchor": [
    171.34,
    128.33
   ],
   "tangentDeg": 142.66,
   "waterNormal": [
    0.1214,
    -0.9926
   ],
   "length": 257.24,
   "waterFraction": 0.251,
   "painted": [
    6,
    6,
    306,
    296
   ]
  },
  {
   "file": "edges/shore-7.webp",
   "w": 224,
   "h": 320,
   "scale": 0.952381,
   "anchor": [
    152.76,
    165.49
   ],
   "tangentDeg": 104.43,
   "waterNormal": [
    0.9982,
    0.0601
   ],
   "length": 234.14,
   "waterFraction": 0.265,
   "painted": [
    6,
    6,
    218,
    314
   ]
  },
  {
   "file": "edges/shore-8.webp",
   "w": 320,
   "h": 267,
   "scale": 0.97561,
   "anchor": [
    159.97,
    177.03
   ],
   "tangentDeg": 32.11,
   "waterNormal": [
    -0.0772,
    0.997
   ],
   "length": 276.34,
   "waterFraction": 0.264,
   "painted": [
    6,
    6,
    314,
    261
   ]
  }
 ],
 "walls": [
  {
   "file": "edges/wall-1.webp",
   "w": 368,
   "h": 372,
   "scale": 1.0,
   "rimAnchor": [
    183.5,
    61.47
   ],
   "tangentDeg": 16.68,
   "rimLength": 339.03,
   "rimBend": 11.0,
   "faceDepth": 244.47,
   "painted": [
    6,
    6,
    362,
    366
   ]
  },
  {
   "file": "edges/wall-2.webp",
   "w": 307,
   "h": 384,
   "scale": 0.843956,
   "rimAnchor": [
    153.0,
    103.97
   ],
   "tangentDeg": 43.29,
   "rimLength": 371.58,
   "rimBend": 18.44,
   "faceDepth": 160.46,
   "painted": [
    5,
    5,
    302,
    379
   ]
  },
  {
   "file": "edges/wall-3.webp",
   "w": 341,
   "h": 384,
   "scale": 0.897196,
   "rimAnchor": [
    170.5,
    71.91
   ],
   "tangentDeg": 31.56,
   "rimLength": 357.4,
   "rimBend": 19.37,
   "faceDepth": 216.07,
   "painted": [
    5,
    5,
    337,
    378
   ]
  },
  {
   "file": "edges/wall-4.webp",
   "w": 287,
   "h": 384,
   "scale": 0.815287,
   "rimAnchor": [
    143.0,
    96.37
   ],
   "tangentDeg": 39.2,
   "rimLength": 327.68,
   "rimBend": 13.24,
   "faceDepth": 186.18,
   "painted": [
    5,
    5,
    282,
    379
   ]
  },
  {
   "file": "edges/wall-5.webp",
   "w": 368,
   "h": 376,
   "scale": 1.0,
   "rimAnchor": [
    183.0,
    52.84
   ],
   "tangentDeg": 4.18,
   "rimLength": 326.55,
   "rimBend": 17.54,
   "faceDepth": 255.01,
   "painted": [
    6,
    6,
    362,
    370
   ]
  },
  {
   "file": "edges/wall-6.webp",
   "w": 304,
   "h": 384,
   "scale": 0.843956,
   "rimAnchor": [
    151.5,
    121.15
   ],
   "tangentDeg": 135.22,
   "rimLength": 379.76,
   "rimBend": 15.14,
   "faceDepth": 168.53,
   "painted": [
    5,
    5,
    299,
    379
   ]
  },
  {
   "file": "edges/wall-7.webp",
   "w": 354,
   "h": 384,
   "scale": 0.950495,
   "rimAnchor": [
    177.5,
    63.31
   ],
   "tangentDeg": 20.4,
   "rimLength": 336.67,
   "rimBend": 7.1,
   "faceDepth": 241.59,
   "painted": [
    5,
    6,
    351,
    379
   ]
  },
  {
   "file": "edges/wall-8.webp",
   "w": 302,
   "h": 384,
   "scale": 0.818763,
   "rimAnchor": [
    150.0,
    100.49
   ],
   "tangentDeg": 44.89,
   "rimLength": 376.62,
   "rimBend": 19.62,
   "faceDepth": 156.58,
   "painted": [
    5,
    4,
    297,
    379
   ]
  }
 ],
 "materials": {
  "lake-water": {
   "file": "materials/lake-water.webp",
   "w": 512,
   "h": 512,
   "scale": 0.408293,
   "mean": [
    15.399,
    97.579,
    129.202
   ]
  },
  "river-water": {
   "file": "materials/river-water.webp",
   "w": 512,
   "h": 512,
   "scale": 0.408293,
   "mean": [
    24.173,
    122.824,
    139.298
   ]
  },
  "shore-gravel": {
   "file": "materials/shore-gravel.webp",
   "w": 512,
   "h": 512,
   "scale": 0.408293,
   "mean": [
    164.467,
    136.1,
    76.925
   ]
  },
  "gorge-wall-lit": {
   "file": "materials/gorge-wall-lit.webp",
   "w": 512,
   "h": 512,
   "scale": 0.408293,
   "mean": [
    174.465,
    137.636,
    98.873
   ]
  },
  "gorge-wall-shadow": {
   "file": "materials/gorge-wall-shadow.webp",
   "w": 512,
   "h": 512,
   "scale": 0.408293,
   "mean": [
    93.241,
    80.679,
    70.398
   ]
  },
  "gorge-floor": {
   "file": "materials/gorge-floor.webp",
   "w": 512,
   "h": 512,
   "scale": 0.408293,
   "mean": [
    72.339,
    57.625,
    43.44
   ]
  },
  "meadow-ground": {
   "file": "materials/meadow-ground.webp",
   "w": 512,
   "h": 512,
   "scale": 0.408293,
   "mean": [
    159.331,
    142.047,
    33.66
   ]
  }
 }
} as const;
